<!--
 Created by Daniil Vat. on 28/3/2021
 Copyright © 2021 Curriculum Ltd. All rights reserved.
-->
<div class="examples-title">Examples of incorrect answers are:</div>
<curr-colored-list-item *ngFor="let item of data; let i = index" [text]="generateListItemText(item)" [index]="i">
</curr-colored-list-item>